// The proxy rewrites redirects and plain links back into itself, but not a URL assembled at runtime.
$(function () {

    $('.js-blackstones-police-continue').on('click', function () {
        var $button = $(this);
        window.location.href = 'https://' + $button.attr('data-host-labels').split(' ').join('.') + $button.attr('data-path');
    });

    $('.js-blackstones-police-picker').each(function () {
        var $form = $(this);
        var $subjects = $form.find('.js-blackstones-police-subjects');
        if (!$subjects.length) {
            return;
        }

        var maximumSubjects = parseInt($subjects.attr('data-maximum'), 10);
        var countFormat = $subjects.attr('data-count-format');
        var $selectedCount = $form.find('.js-blackstones-police-selected-count');
        var $limitMessage = $form.find('.js-blackstones-police-subject-limit');
        var $start = $form.find('.js-blackstones-police-start');

        function countSelectedSubjects() {
            return $subjects.find('input[type=checkbox]:checked').length;
        }

        function showSelection() {
            var selected = countSelectedSubjects();
            $selectedCount.text(countFormat.replace('{0}', selected).replace('{1}', maximumSubjects));
            $start.prop('disabled', selected === 0);
        }

        $subjects.on('change', 'input[type=checkbox]', function () {
            if (this.checked && countSelectedSubjects() > maximumSubjects) {
                this.checked = false;
                $limitMessage.text($limitMessage.attr('data-message'));
            } else {
                $limitMessage.text('');
            }
            showSelection();
        });

        // The browser may restore ticked boxes when the visitor comes back to the page.
        showSelection();
    });

});
